import React, { useState, useMemo, createContext, ReactNode } from "react";

type BankDataType = any[];

type UssdContextType = {
  ussdDetailsLoading: boolean;
  setUssdDetailsLoading: (arg1: boolean) => void;
  ussdBankList: BankDataType;
  setUssdBankList: (arg1: BankDataType) => void;
};

export const UssdContext = createContext<UssdContextType>({
  ussdDetailsLoading: false,
  setUssdDetailsLoading: (arg1) => {},
  ussdBankList: [],
  setUssdBankList: (arg1) => {},
});

const Ussd = ({ children }: { children: ReactNode }) => {
  const [ussdDetailsLoading, setUssdDetailsLoading] = useState(false);
  const [ussdBankList, setUssdBankList] = useState<BankDataType>([]);

  const value = useMemo(
    () => ({
      ussdDetailsLoading,
      setUssdDetailsLoading,
      ussdBankList,
      setUssdBankList,
    }),
    [ussdDetailsLoading]
  );

  return <UssdContext.Provider value={value}>{children}</UssdContext.Provider>;
};

export default Ussd;
